var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "a",
      {
        attrs: { href: _vm.targetRoute },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.handleNotificationClick.apply(null, arguments)
          },
        },
      },
      [_vm._v(_vm._s(_vm.unreadNotification.title))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }